import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';

class Shareholder 
{
    static async all()
    {
        const response = await axios.get('api/company/shareholders');

        return response.data.data;
    }

    static async getLegitShareholders()
    {
        const response = await axios.get('api/company/legit-shareholders/');

        return response.data.data;
    }

    static async getDetails(shareholderId)
    {
        const response = await axios.get(`api/company/shareholders/${shareholderId}`);

        return response.data.data;
    }
    
    static async getShareholderTypeOptions()
    {
        const response = await axios.get('api/company/shareholders/shareholder-type-options');

        return response.data.data;
    }

    static async create(data)
    {
        const response = await axios.post('api/admin/company/shareholder', transformObjectValuesToUpperCase(data));

        return response.data.data;
    }

    static async update(id, data)
    {
        const response = await axios.put(`api/admin/company/shareholder/${id}`, transformObjectValuesToUpperCase(data));
        return response;
    }

    static async delete(id)
    {
        const response = await axios.delete(`api/admin/company/shareholder/${id}`);

        return response;
    }

    static async getShareholdersList() 
    {
        const response = await axios.get('api/company/shareholders-list');

        return response.data.data;
    }

    static async getActiveShareholders() 
    {
        const response = await axios.get('api/company/active-shareholders');

        return response.data.data;
    }
}
export default Shareholder;